import { Icon } from '@iconify/react';
import windowsFilled from '@iconify/icons-ant-design/windows-filled';

// material
import { alpha, styled } from '@material-ui/core/styles';
import { Card, Stack, Typography } from '@material-ui/core';
// utils
import { fShortenNumber } from '../../utils/formatNumber';

// ----------------------------------------------------------------------


const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  // textAlign: 'center',
  fontWeight: 'bold',
  padding: theme.spacing(2, 0, 2, 2),
  color: theme.palette.warning.darker,
  backgroundColor: theme.palette.warning.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  borderRadius: '50%',
  width: theme.spacing(6),
  height: theme.spacing(6),
  justifyContent:"center",
  //marginBottom: theme.spacing(2),
  color: theme.palette.warning.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.warning.dark, 0)} 0%, ${alpha(
    theme.palette.warning.dark,
    0.24
  )} 100%)`
}));


// ----------------------------------------------------------------------

const TOTAL = 1723315;
const COLOR_SELECTED = {
  zalo: "#f6d092"
}
export default function AnalyticsItemOrders({ value, title, channelSelected }) {
  return (
    <RootStyle sx={{ border: channelSelected ? '2px solid ' + COLOR_SELECTED[channelSelected] : 'none', }}>
      <Typography fontWeight={"bold"} variant="subtitle2" sx={{ opacity: 0.72 }}>
        {title}
      </Typography>
      <Stack direction={"row"} spacing={2} sx={{ marginTop: 1 }}>
        <IconWrapperStyle>
          <img style={{ alignSelf:"center" }} width={channelSelected === "zalo" ? "40px" : "32px"} height={channelSelected === "zalo" ? "40px" : "32px"} src={channelSelected === "zalo" ? "/static/icons/icons8-zalo.svg" : "/static/icons/icons8-zalo-disabled.svg"} alt="Zalo" />
        </IconWrapperStyle>
        {/* <Typography alignSelf={"center"}  variant="h3">{fShortenNumber(value)}</Typography> */}
        <Typography alignSelf={"center"}  variant="h3">{value}</Typography>
      </Stack>
    </RootStyle>
  );
}
